import { DimensionRows } from '@type';
import { GRID_INTERNALS } from '../../utils/consts';

export const GROUP_DEPTH = `${GRID_INTERNALS}-depth`;
export const PSEUDO_GROUP_ITEM = `${GRID_INTERNALS}-name`;
export const PSEUDO_GROUP_ITEM_ID = `${GRID_INTERNALS}-id`;
export const PSEUDO_GROUP_ITEM_VALUE = `${GRID_INTERNALS}-value`;
export const PSEUDO_GROUP_COLUMN = `${GRID_INTERNALS}-column`;
export const GROUP_EXPANDED = `${GRID_INTERNALS}-expanded`;
export const GROUP_COLUMN_PROP = `${GRID_INTERNALS}-prop`;
export const GROUP_ORIGINAL_INDEX = `${GRID_INTERNALS}-original-index`;
export const GROUP_EXPAND_BTN = `group-expand`;
export const GROUP_EXPAND_EVENT = `groupexpandclick`;
export const GROUPING_ROW_TYPE: DimensionRows = 'rgRow';
